import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
  {
    ...generateImportColumn("", "question"),
    pinned: "left",
    ...importErrorFunction(), // for display error message in ag-grid in case of error
  },
  {
    ...generateImportColumn("", `industries`),
    minWidth: 150,
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Skill Categories", "skill_categories"),
    ...importErrorFunction(),
    cellRenderer: (props: any) => {
      return props.data?.[`skill_categories`]?.toString();
    },
    filterValueGetter: (props: any) => {
      return props.data?.[`skill_categories`]?.toString();
    },
  },
  {
    ...generateImportColumn("", "careers"),
    ...importErrorFunction(),
    cellRenderer: (props: any) => {
      return props.data?.[`careers`]?.toString();
    },
    filterValueGetter: (props: any) => {
      return props.data?.[`careers`]?.toString();
    },
  },
  {
    ...generateImportColumn("Occupational Groups", "occupational_groups"),
    ...importErrorFunction(),
    cellRenderer: (props: any) => {
      return props.data?.[`occupational_groups`]?.toString();
    },
    filterValueGetter: (props: any) => {
      return props.data?.[`occupational_groups`]?.toString();
    },
  },
  { ...generateImportColumn("", "description"), ...importErrorFunction() },
  {
    ...generateImportColumn("Answer Option", "answer_option"),
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Master Type", "master_type"),
    ...importErrorFunction(),
  },
];
export default columnDefs;
